import React from 'react'
import { StyledPNVideoPlayButton } from './PNVideoPlayButton.styled'
import { IconVideoPlay } from '../../../icons'
import { PNCardOverlayButtonScale, PNFontScales } from '../cards/PNArticleCard'

export interface PNVideoPlayButtonProps {
    overlayButtonScale?: PNCardOverlayButtonScale
}

export const PNVideoPlayButton: React.FC<PNVideoPlayButtonProps> = ({
    overlayButtonScale = 'M',
}) => {
    // todo: leave it here to add actual events in the future
    function handleClick() {}
    return (
        <StyledPNVideoPlayButton
            onClick={handleClick}
            title="Video"
            overlayButtonScale={overlayButtonScale}
            tabIndex={-1}
        >
            <IconVideoPlay />
        </StyledPNVideoPlayButton>
    )
}
